import { render, staticRenderFns } from "./NutritionFacts.vue?vue&type=template&id=26db1cab"
import script from "./NutritionFacts.vue?vue&type=script&lang=ts"
export * from "./NutritionFacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports